var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.7571C20 16.7571 12 22.7571 12 22.7571C12 22.7571 4 16.7571 4 10.7571C4 8.63535 4.84285 6.60052 6.34315 5.10023C7.84344 3.59993 9.87827 2.75708 12 2.75708C14.1217 2.75708 16.1566 3.59993 17.6569 5.10023C19.1571 6.60052 20 8.63535 20 10.7571Z",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7571C13.6569 13.7571 15 12.4139 15 10.7571C15 9.10023 13.6569 7.75708 12 7.75708C10.3431 7.75708 9 9.10023 9 10.7571C9 12.4139 10.3431 13.7571 12 13.7571Z",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMapPin);
export default __webpack_public_path__ + "static/media/active-map-pin.b7dc910547cf962b7b52e6aa6a0bcd9b.svg";
export { ForwardRef as ReactComponent };